import { DeliveryStatus } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { InformationOutlinedIcon } from '@synergy/theme-next';
import { PoolFormattedMessage } from '@synergy/components-next';
import { PoolRow, PoolTypography } from '@synergy/components-next';
import { ReactElement } from 'react';
import { Stack, Tooltip } from '@mui/material';

import { ArticleDetailPriceContainerDetailMainPrice } from './article-detail-price-container-main-price';
import { ArticleDetailPriceContainerDetailPricesPerQuantity } from './article-detail-price-container-price-per-quantity';
import { useArticleDetailContext } from '../article-detail';

const ArticleNotAvailableInfo = (): ReactElement => {
    return (
        <Stack direction="row" alignItems="center" gap={1} typography="h4">
            <Tooltip
                variant="light"
                placement="bottom-start"
                title={
                    <Stack gap={0.5}>
                        <PoolRow>
                            <InformationOutlinedIcon />
                            <strong>
                                <FormattedMessage id="app.article.detail.notAvailable" />
                            </strong>
                        </PoolRow>
                        <PoolFormattedMessage id="app.article.detail.notAvailable.info" />
                    </Stack>
                }
            >
                <Stack>
                    <InformationOutlinedIcon fontSize="inherit" />
                </Stack>
            </Tooltip>
            <FormattedMessage id="app.article.detail.notAvailable" />
        </Stack>
    );
};

const PriceOnRequestInfo = (): ReactElement => {
    return <PoolTypography variant="h4" translationId="app.article.priceOnRequest" />;
};

export const ArticleDetailPriceContainer = (): ReactElement | null => {
    const { article } = useArticleDetailContext();
    const { orderUnit, contentUnit, contentQuantity, isAvailable, deliveryStatus } = article;

    return (
        <Stack gap={1}>
            <PoolTypography variant="body2">
                <FormattedMessage
                    id="app.article.detail.price"
                    values={{
                        priceQuantity: article.priceQuantity && article.priceQuantity > 1 && article.priceQuantity,
                        unit: orderUnit,
                        contentQuantity,
                        contentUnit,
                        optional: chunks => contentQuantity && contentUnit && chunks,
                    }}
                />
            </PoolTypography>

            {isAvailable ? (
                <Stack gap={0.5}>
                    <ArticleDetailPriceContainerDetailMainPrice />
                    <ArticleDetailPriceContainerDetailPricesPerQuantity />
                </Stack>
            ) : deliveryStatus === DeliveryStatus.OnRequest ? (
                <PriceOnRequestInfo />
            ) : (
                <ArticleNotAvailableInfo />
            )}
        </Stack>
    );
};
